import {
  Component,
  OnInit,
  QueryList,
  ViewChildren,
  ElementRef,
  ViewChild,
  HostListener,
} from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UxserviceService } from 'src/app/shared/services/uxservice.service';
import { Auth } from '@angular/fire/auth';
import { doc, Firestore, getDoc } from '@angular/fire/firestore';
import { MatDialog } from '@angular/material/dialog';
import { ServiceOfferDialogComponent } from '../service-offer-dialog/service-offer-dialog.component';
// import { RoleSelectionDialogComponent } from '../role-selection-dialog/role-selection-dialog.component';

import {
  LandingService,
  Category,
  Equipment,
} from 'src/app/shared/services/landing.service';

@Component({
  selector: 'app-landingpage',
  templateUrl: './landingpage.component.html',
  styleUrls: ['./landingpage.component.scss'],
})
export class LandingpageComponent implements OnInit {
  @ViewChild('fromRef') fromField!: ElementRef;
  @ViewChild('fromCalendar') fromCalendar!: ElementRef;

  @ViewChild('whereRef') whereField!: ElementRef;
  @ViewChild('emiratePopup') emiratePopup!: ElementRef;
  @ViewChild('whatRef') whatField!: ElementRef;

  @ViewChild('toRef') toField!: ElementRef;
  @ViewChild('toCalendar') toCalendar!: ElementRef;

  whatValue: string = '';
  isLoaded: boolean = false;
  isDragging = false;

  aiOpen = false;
  
  startX = 0;
  startLeft = 0;
  imagesLoadedCount = 0;

  onImageLoad() {
    this.imagesLoadedCount++;
  }

  private async waitForImages(targetCount: number, timeoutMs: number = 3000): Promise<void> {
    if (targetCount <= 0) return;

    return new Promise((resolve) => {
      const startTime = Date.now();
      const interval = setInterval(() => {
        const elapsed = Date.now() - startTime;
        if (this.imagesLoadedCount >= targetCount || elapsed >= timeoutMs) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });
  }

  @HostListener('window:resize')
  onWindowResize() {
    setTimeout(() => {
      this.checkScrollbarVisibility();
      if (this.showCategoryScrollbar) {
        this.updateThumbPosition();
      }
    });
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as Node;

    const clickedInsideField =
      this.whatField?.nativeElement.contains(target) ||
      this.whereField?.nativeElement.contains(target) ||
      this.fromField?.nativeElement.contains(target) ||
      this.toField?.nativeElement.contains(target);

    // RESET ACTIVE FIELD IF CLICKED ANYWHERE ELSE
    if (!clickedInsideField) {
      this.activeField = null;
    }

    // FROM CALENDAR CLOSE CONDITION
    if (this.showCalendarFrom) {
      if (
        !this.fromField?.nativeElement.contains(target) &&
        !this.fromCalendar?.nativeElement.contains(target)
      ) {
        this.showCalendarFrom = false;
      }
    }

    // EMIRATE POPUP CLOSE
    if (this.showEmirates) {
      if (
        !this.whereField?.nativeElement.contains(target) &&
        !this.emiratePopup?.nativeElement.contains(target)
      ) {
        this.showEmirates = false;
      }
    }

    // TO CALENDAR CLOSE CONDITION
    if (this.showCalendarTo) {
      if (
        !this.toField?.nativeElement.contains(target) &&
        !this.toCalendar?.nativeElement.contains(target)
      ) {
        this.showCalendarTo = false;
      }
    }
  }

  highlightStyle = {
    width: '0px',
    left: '0px',
  };

  mostDemanded$!: Observable<Equipment[]>;

  moveHighlight(ref: HTMLElement) {
    const parentRect = ref.parentElement!.getBoundingClientRect();
    const rect = ref.getBoundingClientRect();

    // this.highlightStyle = {
    //   // width: rect.width + 'px',
    //   left: (rect.left - parentRect.left) + 'px'
    // };
  }

  /* -------------------------
     CATEGORY / EQUIPMENT DATA
     ------------------------- */

  categories$!: Observable<Category[]>;
  emirateEquipments$!: Observable<
    { emirate: string; equipments: Equipment[] }[]
  >;

  // 👉 Added to support search matching
  categoriesList: Category[] = [];

  /* -------------------------
     EMIRATE SELECTOR
     ------------------------- */

  showEmirates = false;
  activeField: string | null = null;
  selectedEmirate: string | null = null;

  emirates = [
    { name: 'Abu Dhabi', map: '../../../../assets/landingpage/abudhabi.png' },
    { name: 'Ajman', map: '../../../../assets/landingpage/ajman.png' },
    { name: 'Dubai', map: '../../../../assets/landingpage/dubai.png' },
    { name: 'Fujairah', map: '../../../../assets/landingpage/fuja.png' },
    { name: 'Ras Al Khaimah', map: '../../../../assets/landingpage/ras.png' },
    { name: 'Sharjah', map: '../../../../assets/landingpage/sharjah.png' },
    { name: 'Umm Al Quwain', map: '../../../../assets/landingpage/umm.png' },
  ];

  /* -------------------------
     CAROUSEL
     ------------------------- */

  @ViewChildren('carouselRef') carousels!: QueryList<
    ElementRef<HTMLDivElement>
  >;

  /* -------------------------
     CALENDAR SYSTEM
     ------------------------- */

  currentDate: Date = new Date();
  currentMonth: number = this.currentDate.getMonth();
  currentYear: number = this.currentDate.getFullYear();

  weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  calendarDays: any[] = [];

  showCalendarFrom: boolean = false;
  showCalendarTo: boolean = false;

  selectedStart: string | null = null;
  selectedEnd: string | null = null;

  /* -------------------------
     CALENDAR COMPUTED MONTH
     
     ------------------------- */
  get currentMonthName() {
    return new Date(this.currentYear, this.currentMonth).toLocaleString(
      'default',
      { month: 'long' },
    );
  }

  constructor(
    private router: Router,
    public ux: UxserviceService,
    private landingService: LandingService,
    private auth: Auth,
    private afs: Firestore,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.loadCategories();
    this.loadEquipmentsByEmirate();
    this.generateCalendar();
    // removed checkRoleAndShowDialog based on user feedback
  }

  // checkRoleAndShowDialog removed

  openFromCalendar(event: Event) {
    this.activeField = 'from';
    this.showCalendarFrom = true;
    this.showCalendarTo = false;
    event.stopPropagation();
  }

  getRatePeriod(equip: any): string {
    if (equip.hasDailyRate !== false && Number(equip.dailyRate) > 0) {
      return '/ day';
    } else if (equip.hasWeeklyRate !== false && Number(equip.weeklyRate) > 0) {
      return '/ week';
    } else if (equip.hasMonthlyRate !== false && Number(equip.monthlyRate) > 0) {
      return '/ month';
    } else if (equip.hasTripRate !== false && Number(equip.tripRate) > 0) {
      return '/ trip';
    } else if (equip.hasPerCubicMetreRate !== false && Number(equip.perCubicMetreRate) > 0) {
      return '/ cbm';
    }
    return '/ day';
  }

  getRatePrice(equip: any): number {
    if (equip.hasDailyRate !== false && Number(equip.dailyRate) > 0) {
      return equip.dailyRate;
    } else if (equip.hasWeeklyRate !== false && Number(equip.weeklyRate) > 0) {
      return equip.weeklyRate;
    } else if (equip.hasMonthlyRate !== false && Number(equip.monthlyRate) > 0) {
      return equip.monthlyRate;
    } else if (equip.hasTripRate !== false && Number(equip.tripRate) > 0) {
      return equip.tripRate;
    } else if (equip.hasPerCubicMetreRate !== false && Number(equip.perCubicMetreRate) > 0) {
      return equip.perCubicMetreRate;
    }
    return equip.dailyRate || 0;
  }

  openToCalendar(event: Event) {
    this.activeField = 'to';
    this.showCalendarTo = true;
    this.showCalendarFrom = false;
    event.stopPropagation();
  }

  /* -------------------------
     LOAD CATEGORIES
     ------------------------- */

  private loadCategories() {
    this.categories$ = this.landingService.getCategories();

    this.categories$.subscribe((list) => {
      this.categoriesList = list;

      // ⭐ WAIT for DOM to render
      setTimeout(() => {
        this.checkScrollbarVisibility();
        this.initCustomScrollbar();
        this.updateThumbPosition();
      }, 50);
    });
  }

  /* -------------------------
     LOAD EQUIPMENT BY EMIRATE
     ------------------------- */

  private loadEquipmentsByEmirate() {
    this.ux.showOverlay('Fetching equipments...');

    this.landingService.getEquipmentsByEmirate().subscribe((data) => {
      this.emirateEquipments$ = new Observable(sub => sub.next(data));
      this.isLoaded = true;
      this.ux.closeOverlay();
    });

    this.mostDemanded$ = this.landingService.getMostDemanded();
  }

  /* -------------------------
     CAROUSEL SCROLL
     ------------------------- */

  scrollLeft(index: number) {
    const carousel = this.carousels.toArray()[index].nativeElement;
    carousel.scrollBy({ left: -300, behavior: 'smooth' });
  }

  scrollRight(index: number) {
    const carousel = this.carousels.toArray()[index].nativeElement;
    carousel.scrollBy({ left: 300, behavior: 'smooth' });
  }

  /* -------------------------
     EMIRATE SELECTOR
     ------------------------- */

  toggleEmirates() {
    this.showEmirates = !this.showEmirates;
  }

  selectEmirate(emirate: any) {
    this.selectedEmirate = emirate.name;
    this.showEmirates = false;
  }

  setActive(field: string) {
    this.activeField = field;
  }

  /* -------------------------
     CALENDAR FUNCTIONS
     ------------------------- */

  generateCalendar() {
    let days = [];
    let firstDay = new Date(this.currentYear, this.currentMonth, 1).getDay();
    let lastDate = new Date(
      this.currentYear,
      this.currentMonth + 1,
      0,
    ).getDate();

    const today = new Date();
    const isCurrentMonth =
      today.getFullYear() === this.currentYear &&
      today.getMonth() === this.currentMonth;

    // Add empty placeholders
    for (let i = 0; i < firstDay; i++) {
      days.push({ date: '', inactive: true, isToday: false });
    }

    // Add real days
    for (let d = 1; d <= lastDate; d++) {
      days.push({
        date: d,
        inactive: false,
        isToday: isCurrentMonth && d === today.getDate(),
      });
    }

    this.calendarDays = days;
  }

  prevMonth() {
    this.currentMonth--;
    if (this.currentMonth < 0) {
      this.currentMonth = 11;
      this.currentYear--;
    }
    this.generateCalendar();
  }

  nextMonth() {
    this.currentMonth++;
    if (this.currentMonth > 11) {
      this.currentMonth = 0;
      this.currentYear++;
    }
    this.generateCalendar();
  }

  selectStartDay(day: any) {
    if (day.inactive) return;
    this.selectedStart = `${day.date}/${this.currentMonth + 1}/${this.currentYear}`;
    this.showCalendarFrom = false;
  }

  selectEndDay(day: any) {
    if (day.inactive) return;
    this.selectedEnd = `${day.date}/${this.currentMonth + 1}/${this.currentYear}`;
    this.showCalendarTo = false;
  }

  /* -------------------------
     NAVIGATION
     ------------------------- */

  goToCategory(id: string) {
    if (!id) {
      this.ux.showError('Invalid category.');
      return;
    }

    this.router.navigate(['/category', id]);
  }

  performSearch() {
    if (!this.whatValue.trim()) {
      this.ux.showError("Please enter what you're searching for.");
      return;
    }

    if (!this.selectedEmirate) {
      this.ux.showError('Please select an Emirate.');
      return;
    }

    // Match category
    const matchedCategory = this.categoriesList.find((cat) =>
      this.whatValue.toLowerCase().includes(cat.name.toLowerCase()),
    );

    if (!matchedCategory) {
      this.ux.showError('No category found for this search.');

      return;
    }

    this.router.navigate(['/category', matchedCategory.id], {
      queryParams: {
        what: this.whatValue,
        emirate: this.selectedEmirate,
        from: this.selectedStart || '',
        to: this.selectedEnd || '',
      },
    });
  }
  viewAll(emirate?: string) {
    if (emirate) {
      this.router.navigate(['/category', 'all'], { queryParams: { emirate } });
    } else {
      this.router.navigate(['/category', 'all']);
    }
  }

  openServiceOfferDialog() {
    this.router.navigate(['/register-business']);
  }

  /* -------------------------
     REVIEW
     ------------------------- */

  @ViewChild('categoryScroll', { static: false })
  scrollContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('customThumb', { static: false })
  thumb!: ElementRef<HTMLDivElement>;

  initialized = false;
  showCategoryScrollbar = false;

  private checkScrollbarVisibility() {
    if (!this.scrollContainer) return;
    const el = this.scrollContainer.nativeElement;
    // Adding a tolerance just in case
    this.showCategoryScrollbar = el.scrollWidth > el.clientWidth + 2;
  }

  private updateThumbPosition() {
    if (!this.scrollContainer || !this.thumb) return;

    const el = this.scrollContainer.nativeElement;
    const track = this.thumb.nativeElement.parentElement as HTMLElement;

    const maxScrollLeft = el.scrollWidth - el.clientWidth;

    // If no scrolling is possible, keep thumb at start
    if (maxScrollLeft <= 0) {
      this.thumb.nativeElement.style.left = '0px';
      return;
    }

    const scrollRatio = el.scrollLeft / maxScrollLeft;

    const trackWidth = track.offsetWidth;
    const thumbWidth = this.thumb.nativeElement.offsetWidth;

    const thumbMax = trackWidth - thumbWidth;
    const thumbPos = thumbMax * scrollRatio;

    this.thumb.nativeElement.style.left = `${thumbPos}px`;
  }

  onScroll() {
    if (!this.isDragging) {
      this.updateThumbPosition();
    }
  }

  initCustomScrollbar() {
    if (!this.scrollContainer || !this.thumb) return;

    const thumbEl = this.thumb.nativeElement;

    thumbEl.addEventListener('mousedown', (e: MouseEvent) => {
      // Check if scrolling is necessary
      const scrollEl = this.scrollContainer.nativeElement;
      if (scrollEl.scrollWidth <= scrollEl.clientWidth) return;

      this.isDragging = true;
      this.startX = e.clientX;
      this.startLeft = parseInt(window.getComputedStyle(thumbEl).left, 10) || 0;
      document.body.classList.add('no-select');
      e.preventDefault(); // Prevent text selection
    });

    document.addEventListener('mousemove', (e: MouseEvent) => {
      if (!this.isDragging) return;

      const track = this.thumb.nativeElement.parentElement as HTMLElement;
      const trackWidth = track.offsetWidth;
      const thumbWidth = this.thumb.nativeElement.offsetWidth;
      const maxLeft = trackWidth - thumbWidth;

      const delta = e.clientX - this.startX;
      let newLeft = this.startLeft + delta;

      newLeft = Math.max(0, Math.min(maxLeft, newLeft));

      this.thumb.nativeElement.style.left = newLeft + 'px';

      const scrollEl = this.scrollContainer.nativeElement;
      const maxScrollLeft = scrollEl.scrollWidth - scrollEl.clientWidth;

      if (maxLeft > 0) {
        const ratio = newLeft / maxLeft;
        scrollEl.scrollLeft = maxScrollLeft * ratio;
      }
    });

    document.addEventListener('mouseup', () => {
      this.isDragging = false;
      document.body.classList.remove('no-select');
    });
  }
}
